/**
 * Pure helper: map a list of Friend records into a lookup of userId -> FriendStatus.
 *
 * Used by any screen that needs to tell "already friends / request pending / not
 * a friend" for a list of users (group leaderboards, World Cup squads, etc.).
 */

import type { Friend } from '../types/friends.types'

export type FriendStatus = 'accepted' | 'pending_sent' | 'pending_received' | null

export function buildFriendStatusByUserId(friends: Friend[]): Record<string, FriendStatus> {
  const map: Record<string, FriendStatus> = {}
  for (const f of friends) {
    if (f.friendshipStatus === 'accepted') {
      map[f.id] = 'accepted'
      continue
    }
    if (f.friendshipStatus !== 'pending') continue
    if (f.invitationType === 'sent' && f.inviteeId) {
      map[f.inviteeId] = 'pending_sent'
      continue
    }
    if (f.invitationType === 'received' && f.inviterId) {
      map[f.inviterId] = 'pending_received'
    }
  }
  return map
}
